import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import PropTypes from "prop-types";
import {
  getReasonOfFareIssue,
  getResultCorrectionReasonFareIssue,
  getResultOfFareIssue,
} from "../../../../utils/FareIssueTextDisplay";

const useStyles = makeStyles((theme) => ({
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gridTemplateAreas: `
    "reportData reason userComment userComment userComment"
    "resolvedData result resolveReason resolvedBy comment"
    `,
    gap: 12,
    [theme.breakpoints.down(800)]: {
      gridTemplateColumns: "1fr 1fr",
      gridTemplateAreas: `
        "reportData reason"
        "userComment userComment"
        "resolvedData result"
        "resolveReason resolvedBy"
        "comment"
      `,
    },
    [theme.breakpoints.down(600)]: {
      gridTemplateColumns: "1fr",
      gridTemplateAreas: `
        "reason"
        "reportData"
        "userComment"
        "resolvedData"
        "result"
        "resolveReason"
        "resolvedBy"
        "comment"
      `,
    },
  },
}));

const ResolvedFareIssue = ({ details }) => {
  const classes = useStyles();
  return (
    <div className={classes.grid}>
      {details.version !== "v1" && (
        <>
          <div style={{ gridArea: "reason" }}>
            <Typography color="textSecondary">Powód reklamacji</Typography>
            <Typography>{getReasonOfFareIssue(details.reason)}</Typography>
          </div>
          <div style={{ gridArea: "userComment" }}>
            <Typography color="textSecondary">Komentarz użytkownika</Typography>
            <Typography>{details.mobileUserComments}</Typography>
          </div>
        </>
      )}
      <div style={{ gridArea: "reportData" }}>
        <Typography color="textSecondary">
          Data zgłoszenia reklamacji
        </Typography>
        <Typography>
          {moment(details.reportedAt).local().format("DD.MM.YYYY HH:mm")}
        </Typography>
      </div>
      <div style={{ gridArea: "resolvedData" }}>
        <Typography color="textSecondary">Data zamknięcia</Typography>
        <Typography>
          {moment(details.resolvedAt).local().format("DD.MM.YYYY HH:mm")}
        </Typography>
      </div>
      <div style={{ gridArea: "result" }}>
        <Typography color="textSecondary">Decyzja</Typography>
        <Typography>{getResultOfFareIssue(details.result)}</Typography>
      </div>
      <div style={{ gridArea: "resolveReason" }}>
        <Typography color="textSecondary">Powód</Typography>
        <Typography>
          {getResultCorrectionReasonFareIssue(
            details.resultCorrectionReasonFareIssue,
          )}
        </Typography>
      </div>
      <div style={{ gridArea: "resolvedBy" }}>
        <Typography color="textSecondary">Imię i nazwisko</Typography>
        <Typography>
          {details.resolvedBy.firstName} {details.resolvedBy.lastName}
        </Typography>
      </div>
      <div style={{ gridArea: "comment" }}>
        <Typography color="textSecondary">Notatka</Typography>
        <Typography>{details.resolutionComments}</Typography>
      </div>
    </div>
  );
};

ResolvedFareIssue.propTypes = {
  details: PropTypes.object.isRequired,
};

export default ResolvedFareIssue;
